import { STORAGE_PRIMARY_ORG_IDS } from '@/constants/organization'
import { UserGroup } from '@/types/user.type'

/**
 * Storage Primary Organization 여부를 확인하는 유틸리티 함수
 * middleware, 컴포넌트 등에서 공통으로 사용
 */
export function isStoragePrimaryOrgId(orgId: string | null | undefined): boolean {
  return orgId != null && STORAGE_PRIMARY_ORG_IDS.includes(orgId)
}

/**
 * /rms_v2 접근이 허용되는 그룹 목록
 * Storage Primary Org 리다이렉트, LNB 분기 등에서 공통으로 사용
 * TODO: 임시 위치. 향후 roles 기반 접근 제어로 전환 시 적절한 위치로 리팩토링 예정
 */
export const RMS_V2_ALLOWED_GROUPS: UserGroup[] = [UserGroup.Internal, UserGroup.StorageUse]

/**
 * Storage Primary Organization + RMS v2 허용 그룹 여부를 동시에 확인
 * org가 Storage Primary이고, group이 rms_v2 접근 가능한 그룹인 경우 true
 * middleware, LNB 분기 등에서 공통으로 사용
 */
export function isStoragePrimaryUser(
  orgId: string | null | undefined,
  group: string | null | undefined
): boolean {
  return isStoragePrimaryOrgId(orgId) && RMS_V2_ALLOWED_GROUPS.includes(group as UserGroup)
}

/**
 * "New chat" 진입 시 이동할 메인 페이지 경로.
 * Storage Primary 유저는 /rms_v2가 메인이므로 그쪽으로, 그 외에는 /analytics.
 * Recents 페이지 / Cmd+K Command Palette의 New chat에서 공통 사용.
 */
export function getNewChatRoute(
  orgId: string | null | undefined,
  group: string | null | undefined
): string {
  return isStoragePrimaryUser(orgId, group) ? '/rms_v2' : '/analytics'
}
